module.exports = __webpack_public_path__ + "static/media/9-质量管理系统.db9a3863.png";